export default __webpack_public_path__ + "add0228.png";